// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@media (max-width: 640px) {\n.no-scrollbar[data-v-23703cec] {\n\t\t-ms-overflow-style: none; /* IE and Edge */\n\t\tscrollbar-width: none; /* Firefox */\n}\n.no-scrollbar[data-v-23703cec]::-webkit-scrollbar {\n\t\tdisplay: none; /* Chrome, Safari, Opera */\n}\n.snap-x[data-v-23703cec] {\n\t\t-webkit-overflow-scrolling: touch;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
